import {cssVal, getDataByCodePostal, getDataBySiren, newInput, tryToDate} from "@/data/helpers";
import {def} from "@/data/dictionnaire";


export const dissolution = {
    title: "Dissolution",
    texte: "<strong>{{societeGroup.societeDenomination}} [[({{societeGroup.sigle}})]]</strong> {{societeGroup.societeFormeJuridique}}, au capital de {{societeGroup.societeCapital}} €, Siège : {{siegeSocialGroup.societeAdresse}} [[{{siegeSocialGroup.societeAdresse2}}]] {{siegeSocialGroup.societeCodePostal}} {{siegeSocialGroup.societeVille}}, RCS : {{societeGroup.societeRcsVille}} N°{{societeGroup.societeRcs}}.<br>Selon {{acteGroup.auTermeAssembleDecision}} en date du {{acteGroup.dateDu}}, il a été décidé la dissolution anticipée de la société à compter du {{acteGroup.dateEffet}}. Liquidateur : {{liquidateurGroup.prenom}} {{liquidateurGroup.nom}}, {{liquidateurGroup.adresse}}[[, {{liquidateurGroup.adresseSuite}}]],  {{liquidateurGroup.codePostal}} {{liquidateurGroup.ville}}. Le siège de la liquidation est fixé {{liquidateurGroup.siegeLiquidation}}, où sera adressée la correspondance et seront notifiés tous actes et documents. Formalités au RCS {{societeGroup.societeRcsVille}}.",
    script: (text, varText, attribute) => {
        let tmpText = "";
        switch (attribute) {
            case "acteGroup.dateDu":
            case "acteGroup.dateEffet":
                tmpText = cssVal(tryToDate(varText[attribute]));
                break;
            default:
                return undefined;
        }
        return tmpText;
    },
    model: {
        societeGroup: [{}],
        siegeSocialGroup: [{}],
        liquidateurGroup: [{}],
    },
    schema: [
        {
            //0
            name: "societeGroup",
            label: "La société",
            type: "group",
            value: [{}],
            children: [
                newInput(def.rcs, '_required', {name: 'societeRcs',
                    on: {
                        change: async (val) => {
                            val = val.target.value.replaceAll(' ', '');
                            if (val.length !== 9) {
                                return false;
                            }

                            const data = await getDataBySiren(val);
                            if(Object.keys(data).length === 0) {
                                return false;
                            }

                            dissolution.model.societeGroup[0] = data.values.societe;
                            dissolution.model.siegeSocialGroup[0] = data.values.siegeSocial;

                            const dataCP = await getDataByCodePostal(data.values.siegeSocial.societeCodePostal, data.values.siegeSocial.societeVille);
                            dissolution.schema[1].children[3].options = dataCP.options;
                            dissolution.model.siegeSocialGroup[0].societeVille = dataCP.ville_slug;
                        }
                    }
                }),
                newInput(def.lieuImmatriculation, '_required', {name: 'societeRcsVille'}),
                newInput(def.denomination, '_required', {name: 'societeDenomination'}),
                newInput(def.sigle),
                newInput(def.formesSocietes, '_required', {name: 'societeFormeJuridique'}),
                newInput(def.montantCapital, '_required', {name: 'societeCapital'}),
            ]
        },
        {
            //1
            name: "siegeSocialGroup",
            label: "Siège social",
            type: "group",
            value: [{}],
            children: [
                newInput(def.adresse, '_required', {name: 'societeAdresse'}),
                newInput(def.adresseSuite, '_required', {name: 'societeAdresse2'}),
                newInput(def.codePostal, '_required', {
                    name: 'societeCodePostal',
                    on: {
                        change: async (val) => {
                            val = val.target.value;
                            if (val.length !== 5) {
                                return false;
                            }

                            const data = await getDataByCodePostal(val);

                            if (Object.keys(data).length === 0) {
                                return false;
                            }

                            dissolution.schema[1].children[3].options = data.options;
                            dissolution.model.siegeSocialGroup[0].societeVille = data.ville_slug;
                            dissolution.model.societeGroup[0].societeRcsVille = data.greffe;
                        }
                    }
                }),
                newInput(def.ville, '_validUniqueSelect', {name: 'societeVille'}),
            ]
        },
        {
            //2
            name: "acteGroup",
            label: "Acte",
            type: "group",
            value: [{}],
            children: [
                newInput(def.auTermeAssembleDecision, '_required'),
                newInput(def.dateDu, '_required'),
                newInput(def.dateEffet, '_required'),
            ]
        },
        {
            //3
            name: "liquidateurGroup",
            label: "Liquidateur",
            type: "group",
            value: [{}],
            children: [
                newInput(def.nom , '_required'),
                newInput(def.prenom , '_required'),
                newInput(def.adresse , '_required'),
                newInput(def.adresseSuite),
                newInput(def.codePostal , '_required', {
                    on: {
                        change: async (val) => {
                            val = val.target.value;
                            if (val.length !== 5) {
                                return false;
                            }

                            const data = await getDataByCodePostal(val);

                            if (Object.keys(data).length === 0) {
                                return false;
                            }

                            dissolution.schema[3].children[5].options = data.options;
                            dissolution.model.liquidateurGroup[0].ville = data.ville_slug;
                        }
                    }
                }),
                newInput(def.ville , '_required'),
                newInput(def.siegeLiquidation , '_required'),
            ]
        },
    ]
};